<style scoped>
    @import url("../../styles/smartControl/atuarSC.scss");
</style>

<template>
    <div class="box_atuarSC">

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-gamepad-square-outline</v-icon>
            <span class="ml-2">Atuação remota imediata</span>
        </div>

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="painelGeral" v-if="!flagLoading && !flagMsgSistema">
            Desabilitado
        </div>

    </div>
</template>

<script>
//import axios from 'axios'

export default {

    //components:{PainelInitSC},

    data() {
        return {
            //
            //r:'/dadoslipordia',

            // loading
            flagLoading:true,

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
        }
    },

    methods:{

        preInit() {

            /*let emailCliente = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = { 'cliente': emailCliente }

            let url = self.$store.state.pathAxiosBASE + '/getsysuser' // concat

            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                let lisys = res.data.result
                self.liExecSys = lisys

                self.flagLoading = false // -- encerrar loading
            })*/
           this.flagLoading = false
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false
            this.preInit()
        }
    }
}
</script>